import script from "./InvestmentCard.vue?vue&type=script&setup=true&lang=js"
export * from "./InvestmentCard.vue?vue&type=script&setup=true&lang=js"

import "./InvestmentCard.vue?vue&type=style&index=0&id=748d1e90&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-748d1e90"]])

export default __exports__